// Le vocabulaire des missions et des candidatures. Comme pour le vivier, ces listes sont
// reprises par la base, par la validation des routes et par la consigne du modèle.
// Les lieux, eux, sont dans domaine/lieux.ts : ils servent aussi au vivier.
export { ZONES as REGIONS } from './lieux.ts';

export const STATUTS_MISSION = ['brouillon', 'ouverte', 'pourvue', 'perdue', 'close'] as const;
export type StatutMission = (typeof STATUTS_MISSION)[number];

export const LIBELLES_MISSION: Record<StatutMission, string> = {
  brouillon: 'Brouillon', ouverte: 'Ouverte', pourvue: 'Pourvue', perdue: 'Perdue', close: 'Close',
};

export const STATUTS_CANDIDATURE =
  ['repere', 'retenu', 'ecarte', 'presente', 'retenu_client', 'refuse_client'] as const;
export type StatutCandidature = (typeof STATUTS_CANDIDATURE)[number];

export const LIBELLES_CANDIDATURE: Record<StatutCandidature, string> = {
  repere: 'Repéré', retenu: 'Retenu', ecarte: 'Écarté', presente: 'Présenté',
  retenu_client: 'Retenu par le client', refuse_client: 'Refusé par le client',
};

/** Les deux issues qui exigent un motif. La base le vérifie aussi : c'est volontaire. */
export const REFUS_CANDIDATURE: StatutCandidature[] = ['ecarte', 'refuse_client'];

/** Ordres de grandeur, jamais un chiffre d'affaires exact : une annonce ne doit pas identifier. */
export const TAILLES_CLIENT = [
  'PME (50 à 250 M€)', 'ETI (250 M€ à 1,5 Md€)', 'Grand groupe (> 1,5 Md€)',
  'Filiale de grand groupe', 'Secteur public',
] as const;

export const AXES = ['metier', 'sectorielle', 'maturite_ia', 'preuve', 'seniorite'] as const;
export type Axe = (typeof AXES)[number];

export const LIBELLES_AXES: Record<Axe, string> = {
  metier: 'Adéquation métier', sectorielle: 'Connaissance sectorielle',
  maturite_ia: 'Maturité IA', preuve: 'Preuve au dossier', seniorite: 'Séniorité',
};

/**
 * Pondérations par défaut du cabinet, telles que fixées dans docs/rapprochement.md.
 * Une mission qui ne s'en écarte pas ne stocke rien : une valeur en base signifie
 * « cette mission-là ne se pèse pas comme les autres », et c'est une décision assumée.
 */
export const PONDERATIONS: Record<Axe, number> = {
  metier: 25, sectorielle: 20, maturite_ia: 20, preuve: 20, seniorite: 15,
};
